import { css, StyleSheet } from 'aphrodite'
import cn from 'classnames'
import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { useQueryParams } from '../../hooks/queryString'

import Loader from './Loader'
import Pagination from './Pagination'

export default function Table({
    loading = false,
    emptyMessage = 'Пусто',
    showEmptyMessage = true,
    totalCount = 0,
    pageSize = 15,
    items,
    columns,
    pagination = true,
    renderItem,
    className,
    onPageChange,
    activePage,
    emptyMessageColor = null
}) {
    const params = useQueryParams()

    if (loading) {
        return (
            <div className={css(styles.loaderContainer)}>
                <Loader large center />
            </div>
        )
    }

    if (isEmpty(items) && showEmptyMessage) {
        return (
            <div className={cn(css(styles.emptyMessage), emptyMessageColor)}>
                {emptyMessage}
            </div>
        )
    }

    return (
        <div className={css(styles.tableWrapper)}>
            <table className={cn('table', 'is-striped', 'is-fullwidth', 'is-bordered', css(styles.table), className)}>
                <tbody>
                    {columns && (
                        <tr>
                            {Object.entries(columns).map(([key, value]) => (
                                <th key={key}>
                                    <p className={css(styles.columnHeader)}>{value}</p>
                                </th>
                            ))}
                        </tr>
                    )}
                    {items.map(renderItem)}
                </tbody>
            </table>

            {pagination && (
                <Pagination
                    currentPage={params.page || activePage}
                    totalCount={totalCount}
                    pageSize={pageSize}
                    onPageChange={onPageChange}
                />
            )}
        </div>
    )
}

const styles = StyleSheet.create({
    loaderContainer: {
        marginTop: '2rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    emptyMessage: {
        marginTop: '2rem',
        padding: '1rem',
        borderRadius: '6px',
        // backgroundColor: '#f5f5f5',
        color: '#757575',
        fontSize: '1.2rem',
        textAlign: 'center',
    },
    tableWrapper: {
        overflowX: 'auto',
        width: '100%',
    },
    table: {
        borderCollapse: 'collapse',
        width: '100%',
    },
    columnHeader: {
        width: 'max-content',
        fontWeight: 'bold',
        padding: '0.5rem',
        textAlign: 'left',
    },
})
